import React from "react";
import { toast } from 'react-hot-toast';
import { CancelOutlined } from "@mui/icons-material";

export const kycError = (text: string) =>
    toast.custom(<span className="bg-white flex items-center gap-3 p-4 rounded-lg shadow-xl text-black/80 font-semib
"><CancelOutlined className="text-red-600" /> {text}</span>);
